import React, { useState, useEffect } from "react";

import "../assets/styles/PopUp.scss";
import { Modal } from "react-bootstrap";
import CloseBtn from "assets/icons/Close-1.svg";
import { PROGRAM_CLOSE_DATE } from "constants/schedule";

function RegistrationClosedModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const now = new Date();
    const timeUntilShow = PROGRAM_CLOSE_DATE - now;
    const MAX_TIMEOUT = 2147483647;

    if (timeUntilShow <= 0) {
      setShow(true);
    } else if (timeUntilShow <= MAX_TIMEOUT) {
      const timer = setTimeout(() => {
        setShow(true);
      }, timeUntilShow);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <Modal
        className="modal-overlay pop-up-modal"
        size="lg"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="p-0">
          <button
            type="button"
            className="close close-button position-relative pb-0"
            onClick={handleClose}
          >
            <img src={CloseBtn} alt="modal-close" className="w-30" />
          </button>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="title">
            Blood Glucose Screening Programme 2026 - Closed
          </div>
          <div className="description">
            Thank you for your interest in the Blood Glucose Screening Programme
            2026. The programme has now concluded for the year.
            <br />
            <br />
            We appreciate your participation and encourage you to follow Sun
            Life Malaysia’s social media platforms to stay informed about future
            health initiatives.
          </div>
        </Modal.Body>
        <Modal.Footer className="button-footer p-0"></Modal.Footer>
      </Modal>
    </div>
  );
}

export default RegistrationClosedModal;
